import { LangType } from '../../helpers/lang';
import { buildParams } from '../../helpers/path';
import { PaginationRequest } from '../../types/pagination';
import { SortRequest, WithArchiveRequest } from '../../types/props';
import { managerApiUrl } from './manager-api';
import { baseFetch } from './utils.ts/base-fetch';

const baseUrl = `${managerApiUrl}/form`;
export type FormHelperType = 'none' | 'label' | 'placeholder' | 'sublabel';

export type FormElementTypeType =
  | 'input'
  | 'multi-select'
  | 'datetime'
  | 'select'
  | 'checkbox'
  | 'datetimeRange'
  | 'switch';

export type FormElementType = {
  uuid: string;
  order?: number;
  type: FormElementTypeType;
  info?: {
    options?: LangType[];
    helper?: FormHelperType;
    helper_text?: LangType;
    counter?: boolean;
  };
};

export type FormType = {
  uuid: string;
  name: LangType;
  elements: Partial<FormElementType>[];
  is_deleted?: boolean;
};

export interface FetchFormsRequest extends PaginationRequest, WithArchiveRequest, SortRequest {
  name?: string;
  is_filled?: string;
  executors?: string;
  coordinators?: string;
}

export const fetchFormList = async (params: FetchFormsRequest): Promise<FormType[]> => {
  const response = await baseFetch(baseUrl + buildParams(params));
  return response;
};

export const fetchForm = async (id: string): Promise<FormType> => {
  const response: FormType = await baseFetch(baseUrl + `/${id}`);
  return response;
};

export const postForm = async (params: Partial<FormType>): Promise<FormType> => {
  const response = await baseFetch(baseUrl, {
    method: 'POST',
    body: JSON.stringify(params),
  });
  return response;
};

export const putForm = async (params: Partial<FormType>): Promise<FormType> => {
  const response = await baseFetch(baseUrl + `/${params.uuid}`, {
    method: 'PUT',
    body: JSON.stringify(params),
  });
  return response;
};

export const deleteForm = async (id: string): Promise<FormType> => {
  const response = await baseFetch(baseUrl + `/${id}`, { method: 'DELETE' });
  return response;
};

export const restoreForm = async (id: string): Promise<void> => {
  const response = await baseFetch(baseUrl + `/${id}/restore`, { method: 'POST' });
  return response;
};
